module.exports = __webpack_public_path__ + "static/media/vipps_logo_negativ_rgb.fbc7a5f1.png";